import api from './api';
import { 
  Drug, 
  DrugPrice, 
  BuyDrugRequest, 
  SellDrugRequest, 
  DrugTransaction,
  DrugInventoryResponse
} from '../types';

export const drugService = {
  async getDrugs(): Promise<{ success: boolean; drugs: Drug[] }> {
    const response = await api.get('/drugs/list');
    return response.data;
  },

  async getDrugPrices(): Promise<{ success: boolean; prices: DrugPrice[] }> {
    const response = await api.get('/drugs/prices');
    return response.data;
  },

  async getUserDrugs(): Promise<DrugInventoryResponse> {
    const response = await api.get('/drugs/inventory');
    return response.data;
  },

  async buyDrug(data: BuyDrugRequest): Promise<DrugTransaction> {
    const response = await api.post('/drugs/buy', data);
    return response.data;
  },

  async sellDrug(data: SellDrugRequest): Promise<DrugTransaction> {
    const response = await api.post('/drugs/sell', data);
    return response.data;
  },

  async getTravelCost(destination: string): Promise<{ 
    success: boolean; 
    cost: number; 
    timeMinutes: number; 
    riskLevel: string; 
  }> {
    const response = await api.get(`/drugs/travel-cost/${destination}`);
    return response.data;
  }
};
